module.exports = __webpack_public_path__ + "img/45917ec6-b1ae-4125-8b2d-e802a85baf5c_jdm-logo-default-white.1e9dbfdb.svg";